import React from "react";
import type { OpexCategory } from "@meupedaco/shared";
import { CrudPage } from "../../components/CrudPage";

export const OpexCategoriesPage: React.FC = () => {
  return (
    <CrudPage<OpexCategory>
      title="Categorias OPEX"
      endpoint="/modules/opex-categories"
      searchPlaceholder="Buscar por nome..."
      columns={[
        { label: "Nome", render: (item) => item.name },
        { label: "Ativa", render: (item) => (item.isActive ? "Sim" : "Não") },
      ]}
      formFields={[
        { name: "name", label: "Nome", type: "text", required: true },
        { name: "isActive", label: "Ativa", type: "checkbox" },
      ]}
      initialValues={{
        name: "",
        isActive: true,
      }}
      mapToPayload={(values) => ({
        name: values.name,
        isActive: values.isActive,
      })}
      permissionWrite="CATALOG_OPEX_CATEGORIES_WRITE"
    />
  );
};
